module.exports = __webpack_public_path__ + "img/aquassist_reverse.5dbaba11.png";